import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {Button} from "antd"
import styled from "styled-components"
import {useEffect} from "react"
import CustomerReview from "../../components/CustomerReview"
import {useNavigate} from "react-router-dom"
import {Tile, Tiles} from "../../components/UI/Tiles"
import ReadyToTry from "../../components/ReadyToTry"
import FAQ from "../../components/FAQ"

const RoutingScreen = () => {
	const navigate = useNavigate()

	useEffect(() => {
		document.title = 'АТС24 — Маршрутизация, планирование маршрутов, автоматическая маршрутизация'
	}, [])

	return (
		<>
			<ContentBlock bottom={0} top={3.33}>
				<ContentCard title="Маршрутизация" size="large">
					<p className="description">
						АТС24 — простой и мощный инструмент для планирования маршрутов. Возможность как ручного, так и
						автоматического планирования с возможностью ручной корректировки.
					</p>
					<p>
						<Button color="default" onClick={() => navigate('/contacts')} variant="solid" size="large">
							Попробовать бесплатно
						</Button>
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock top={2.22} bottom={0}>
				<Section>
					<img width="100%" src="./assets/img/png/home/main.png"/>
				</Section>
			</ContentBlock>

			<ContentBlock>
				<ContentCard
					title="Всей командой"
					media={{
						url: "/assets/img/jpg/routing/group.jpg"
					}}
				>
					<p>
						Разделяйте точки по ответственности и маршрутизируйте их всей командой одновременно. Вы всегда
						будете видеть, что делают ваши коллеги.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#E9FAFF">
				<ContentCard title="Автоматически или вручную">
					<p className="description">
						Любая автоматизация — это прекрасно. Но мы считаем, что ручной режим не менее важен, поэтому у
						нас есть оба варианта, включая возможность удобно корректировать маршрут вручную.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock top={0} background="#E9FAFF">
				<ContentCard radius={10} title="Автоматически" size="small"
							 media={{
								 url: "/assets/img/jpg/routing/auto.jpg",
								 radius: 0
							 }}
				>
					<p>
						Мы используем только необходимые и понятные настройки автоматического планирования, а более
						точные подстройки алгоритм выполнит самостоятельно.
					</p>
					<p>
						Вам нужно лишь выбрать склад, указать приоритет и ограничения на количество адресов или время
						работы — дальше автомат сделает всё за вас.
					</p>
				</ContentCard>

				<ContentCard
					title="Ручной режим" size="small" reverse
					media={{
						url: "/assets/img/jpg/routing/manual.jpg"
					}}
				>
					<p>
						Более простого, удобного и информативного конструктора маршрутов вы ещё не встречали.
					</p>
					<p>
						Всё, как в операционных системах: выделяйте, копируйте, вырезайте и вставляйте точки прямо на
						карте.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock>
				<CustomerReview
					author="Роман Козлов, руководитель логистики"
					description="Потрясающий инструмент. Время планирования сократили с двух часов до 15 минут"
					media={{
						url: "/assets/img/png/routing/logo-kover-rent.png",
						width: 200
					}}
				/>
			</ContentBlock>

			<ContentBlock background="#F5F5F5" gap={2}>
				<ContentCard title="Наши преимущества">
					<p className="description">
						Ключевые преимущества нашего инструмента планирования.
					</p>
				</ContentCard>
				<Tiles>
					<Tile>
						<img src="/assets/img/jpg/routing/browser.jpg"/>
						<h3>Работа в браузере</h3>
						<p style={{fontSize: '1rem'}}>
							Никаких установок, серверов, выездов специалистов и других трудностей, характерных для
							классического ПО.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/routing/fast.jpg"/>
						<h3>Очень быстрый</h3>
						<p style={{fontSize: '1rem'}}>
							Вы когда-нибудь работали с 10 000 точками на карте? У нас вы сможете управлять ими без
							задержек.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/routing/on-roads.jpg"/>
						<h3>Маршруты по дорогам</h3>
						<p style={{fontSize: '1rem'}}>
							Мы рассчитываем маршруты строго по дорогам и предоставляем точные данные о расстояниях,
							времени и схемах движения.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/routing/map-point-info.jpg"/>
						<h3>Информация на карте</h3>
						<p style={{fontSize: '1rem'}}>
							Включите отображение времени приёмки и названия клиента прямо на карте, чтобы с первого
							взгляда понимать, что это за точка.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/routing/mobile-app-optimization.jpg"/>
						<h3>Оптимизация в приложении</h3>
						<p style={{fontSize: '1rem'}}>
							Водитель может в любой момент оптимизировать маршрут, если он отклонился от плана.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/routing/geocoder.jpg"/>
						<h3>Геокодирование</h3>
						<p style={{fontSize: '1rem'}}>
							Нет координат клиентов? Не проблема — мы геокодируем адреса и даём возможность указать
							точное место разгрузки.
						</p>
					</Tile>
				</Tiles>
			</ContentBlock>

			<ContentBlock>
				<ContentCard title="Перенос точек" size="small"
							 media={{
								 url: "/assets/img/jpg/routing/move-points.jpg"
							 }}
				>
					<p>
						Транспорт сломался или водитель не вышел на смену? Вы можете быстро заменить транспортное
						средство или водителя.
					</p>
					<p>
						Если нужно перенести точки из одного маршрута в другой — просто вырежьте их и вставьте в нужный
						маршрут.
					</p>
				</ContentCard>
				<ContentCard
					reverse title="Печать документов" size="small"
					media={{
						url: "/assets/img/jpg/routing/print.jpg",
						width: 780
					}}
				>
					<p>
						Нажмите правой кнопкой мыши на маршрут, выберите нужный документ (путевой лист или задание) и
						отправьте его на печать. Все данные о водителе, ТС и адресах будут автоматически заполнены.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock>
				<ReadyToTry/>
			</ContentBlock>

			{/*<ContentBlock background="#F5F5F5">
				<FAQ questions={[
					{
						label: 'Как маршруты попадают в АТС24?',
						children: 'Если вы используете встроенную маршрутизацию АТС24, маршруты автоматически появляются в системе мониторинга сразу после отправки в работу.\n' +
							'Если маршруты планируются во внешних системах (например, 1С), их можно легко загрузить в АТС24 через API или с помощью XLS-файла.'
					},
					{
						label: 'Можно установить датчики самостоятельно?',
						children: 'Да, установка датчиков не требует специальной квалификации. Мы предоставим инструкции и при необходимости проконсультируем на каждом этапе.'
					},
					{
						label: 'Что даёт датчик с CAN?',
						children: 'Датчик, подключённый к CAN-шине, позволяет получать внутренние данные о состоянии автомобиля: общий пробег, уровень топлива, ошибки и другие параметры. Однако не все транспортные средства поддерживают такую установку — перед покупкой рекомендуется проконсультироваться с нашими специалистами.'
					},
					{
						label: 'Мобильное приложение вместо GPS-датчика?',
						children: 'Да, мобильное приложение выполняет те же функции и может использоваться как альтернатива GPS-датчику. Однако следует учитывать, что водитель может выгрузить его из памяти — в этом случае передача координат остановится.'
					},
					{
						label: 'Расход аккумулятора у мобильного приложения',
						children: 'Средний расход заряда составляет 2–5% в час. Точное значение зависит от модели смартфона, состояния аккумулятора и настроек энергосбережения.'
					}
				]}/>
			</ContentBlock>*/}
		</>
	)
}

export default RoutingScreen

const Section = styled.div`
    -webkit-box-shadow: 0 0 10px 2px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0 0 10px 2px rgba(34, 60, 80, 0.2);
    box-shadow: 0 0 10px 2px rgba(34, 60, 80, 0.2);
    border-radius: 10px;
    overflow: hidden;
`